"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemTypes = void 0;
exports.ItemTypes = {
    MiniToolBox: 'minitoolbox',
    Block: 'block'
};
